import { Link } from "@tanstack/react-router";
import { Badge } from "@portal/ui";
import { useMemoUnreadPins, useProjects } from "../../api/queries";
import { ProjectStatusBadge } from "../../features/projects/ProjectStatusBadge";
import { HomeSection } from "../HomeSection";
import { CardStatus } from "./CardStatus";

/**
 * 自分が参加しているプロジェクト。「まずはここを見よう」ボードに未読・更新のピンがあれば、その件数を出す
 * (初めて参加した人が、見るべきものに気づけるように。SPEC §13.6)。件数が取れなくても一覧は出す。
 */
export function MyProjectsCard() {
  const projects = useProjects({ mine: true });
  const unread = useMemoUnreadPins();
  const unreadOf = new Map(unread.data?.projects.map((x) => [x.projectId, x.count]));
  return (
    <HomeSection
      data-testid="my-projects-card"
      title="参加プロジェクト"
      description="自分が参加者になっているプロジェクト"
    >
      <CardStatus
        isPending={projects.isPending}
        isError={projects.isError}
        refetch={() => projects.refetch()}
      />
      {projects.data && projects.data.projects.length === 0 && (
        <p className="text-sm text-muted-foreground">参加しているプロジェクトはありません。</p>
      )}
      {projects.data && projects.data.projects.length > 0 && (
        <ul className="flex max-h-56 flex-col divide-y overflow-y-auto">
          {projects.data.projects.map((p) => (
            <li key={p.id} className="text-sm">
              {/* 行全体をリンクにする(文字以外の余白でも遷移) */}
              <Link
                to="/projects/$projectId"
                params={{ projectId: p.id }}
                className="flex items-center justify-between py-2 hover:bg-accent"
              >
                <span className="hover:underline">{p.name}</span>
                <span className="flex shrink-0 items-center gap-2">
                  {(unreadOf.get(p.id) ?? 0) > 0 && (
                    <Badge
                      variant="warning"
                      title="「まずはここを見よう」に、まだ開いていないメモがあります"
                    >
                      未読 {unreadOf.get(p.id)}
                    </Badge>
                  )}
                  <ProjectStatusBadge status={p.status} />
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </HomeSection>
  );
}
